import { useMutation } from '@tanstack/react-query';
import { transport } from '@opengov/app-core/transport';
import { IEmbedV2 as IEmbed } from '@opengov/reporting-types';

import { useToast } from '../../../../stories/components/Toast/context/useToast.context';
import { IUpdateEmbedPayload } from '../types';
import { embedPickerQueryKeys } from './embedPickerQueryKeys';

export function useUpdateEmbed() {
  const { toggleToast } = useToast();

  return useMutation<IEmbed, Error, IUpdateEmbedPayload>({
    mutationKey: [...embedPickerQueryKeys.all, 'updateEmbed'],
    mutationFn: async ({
      id,
      title,
      description,
      data,
      privateUrl,
      publicUrl,
      chartType,
      type,
      shouldSync,
      reportVersion,
      groupDataBy,
      tableColumns,
      showUpdatedPreview: _showUpdatedPreview,
      displayAccountCodes
    }) => {
      type Payload = {
        id: string;
        title: string;
        description: string;
        data: any;
        should_sync: boolean;
        privateUrl: string;
        publicUrl: string;
        chart_type: string;
        type: string;
        report_version: string;
        display_account_codes: boolean;
        group_data_by?: string;
        table_columns?: string[];
      };

      let payload: Payload = {
        id,
        title,
        description,
        data,
        should_sync: shouldSync,
        privateUrl,
        publicUrl,
        chart_type: chartType,
        type,
        report_version: reportVersion,
        display_account_codes: displayAccountCodes
      };

      if (
        chartType === 'transparency_table' &&
        groupDataBy &&
        tableColumns &&
        tableColumns.length > 0 &&
        tableColumns.length < 3
      ) {
        payload = { ...payload, group_data_by: groupDataBy, table_columns: tableColumns };
      }

      return transport
        .url(`/api/embed_crud_service/v2/embeds/${id}`)
        .json(payload)
        .put()
        .json()
        .then(({ data: responseData }: { data: IEmbed }) => responseData);
    },
    onError: () => {
      toggleToast({ title: 'Could not update embed', severity: 'error' });
    }
  });
}
